<template>
  <!--================Header Menu Area =================-->
  <header class="header_area">
    <div class="main_menu">
      <nav class="navbar navbar-expand-lg navbar-light">
        <div class="container box_1620">
          <!-- Brand and toggle get grouped for better mobile display -->
          <a class="navbar-brand logo_h" href="/">
          <div style="color:white; text-transform: uppercase; font-weight:600; cursor:pointer;">
            <i class="material-icons logo">restore</i>RetainerDesk
        </div></a>
          <button @click="isVisible = !isVisible" class="navbar-toggler" type="button"  data-target="#navbarSupportedContent"  :aria-expanded="[isVisible]" aria-label="Toggle navigation">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <!-- Collect the nav links, forms, and other content for toggling -->
          <div class="navbar-collapse offset" v-show="isVisible">
            <ul class="nav navbar-nav menu_nav justify-content-end">
                
                <li class="nav-item"><a class="nav-link" style="cursor:pointer;" @click="scrollTo()">Features</a></li>

                <li class="nav-item submenu dropdown">
                <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                  aria-expanded="false">Industries</a>
                <ul class="dropdown-menu">
                    <li class="nav-item" @click="isVisible = false">
                        <router-link class="nav-link" to="/reduce-churn-saas">SaaS subscription</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/reduce-churn-bank-insurance">Bank & insurance</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/reduce-churn-physical-products">Physical products</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/reduce-churn-telecom">Telecom & Mobile</router-link>
                    </li>
                </ul>
			    </li>
              <li class="nav-item" style="display:none;" > <router-link class="nav-link" to="/try-free">Try it free</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/pricing">Pricing</router-link></li>
              <li class="nav-item"><a href="https://blog.retainerdesk.com/" class="nav-link" >Blog</a></li>
              <li class="nav-item"><router-link class="nav-link" to="/contact">Contact</router-link></li>
            </ul>

            <ul class="navbar-right">
              <li class="nav-item">
                <button class="button button-header bg" onclick="window.location.href = 'https://app.retainerdesk.com/#/register'">Try it free</button>
              </li>
            </ul>
          </div> 
        </div>
      </nav>
    </div>
  </header>
  <!--================Header Menu Area =================-->
</template>

<script>
export default {
  data() {
    return {
      isVisible: false
    }
  },
  watch:{
    $route (to, from){
        this.isVisible = false;
    },
  }, 
    methods: {
      scrollTo() {

        if(this.$route.path == '/') {
          window.scrollBy(0,700)
          this.isVisible = false;
        } else {
          this.$router.push("/");
        }

      }
    },


}
</script>

<style>

</style>